import {
  column,
  Css,
  emptyCell,
  GridColumn,
  GridDataRow,
  GridTable,
  numericColumn,
  simpleHeader,
} from "@homebound/beam";
import { priceCell } from "src/components";
import { CommitmentOrChangeOrderPdf_LineItemFragment } from "src/routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf.generated";
import { Section } from "../../components/Section";

type PlanBasedBidLinesSectionProps = { lineItems: CommitmentOrChangeOrderPdf_LineItemFragment[] };

export function PlanBasedBidLinesSection({ lineItems }: PlanBasedBidLinesSectionProps) {
  return (
    <Section title="Cost Lines">
      <div css={Css.mb2.$}>
        <GridTable as="table" id="planBasedBidLinesTable" columns={columns} rows={createRows(lineItems)} />
      </div>
    </Section>
  );
}

type HeaderRow = { kind: "header" };
type DataRow = { kind: "data"; data: { option: string; dimensions: string; taxableCostInCents: number } };
type TotalRow = { kind: "total"; data: { totalInCents: number } };
type Row = HeaderRow | DataRow | TotalRow;

const columns: GridColumn<Row>[] = [
  column<Row>({ header: () => "Option", data: ({ option }) => option, total: () => emptyCell }),
  column<Row>({ header: () => "Dimensions", data: ({ dimensions }) => dimensions, total: emptyCell }),
  numericColumn<Row>({
    header: () => "Cost",
    data: ({ taxableCostInCents }) => priceCell({ id: "cost", valueInCents: taxableCostInCents }),
    total: ({ totalInCents }) => priceCell({ id: "totalCost", valueInCents: totalInCents }),
  }),
];

function createRows(lineItems: CommitmentOrChangeOrderPdf_LineItemFragment[]): GridDataRow<Row>[] {
  const dataRows = lineItems
    .filter((cli) => cli.planBasedLineItem)
    .map((cli) => {
      const { groupLine } = cli.planBasedLineItem!;
      return {
        kind: "data" as const,
        id: cli.planBasedLineItem!.id,
        data: {
          option: groupLine.group.displayName,
          dimensions: groupLine.options.map((o) => o.globalOption.name).join(", "),
          taxableCostInCents: cli.taxableCostInCents,
        },
      };
    });
  const totalInCents = dataRows.sum((r) => r.data.taxableCostInCents);
  return [simpleHeader, ...dataRows, { kind: "total" as const, id: "total", data: { totalInCents } }];
}
